import { Component, Input } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { DownloadService } from 'services/download.service';
import { OrderService } from 'services/order.service';
import { ToastService } from 'services/toast.service';

@Component({
    selector: 'proof-of-delivery',
    templateUrl: './proof-of-delivery.component.html',
    standalone: false
})
export class ProofOfDeliveryComponent {
  @Input() documentId: string;

  public deliveryLoading: boolean = false;

  private deliverySubject: Subject<{}> = new Subject();
  public delivery$: Observable<boolean> = this.deliverySubject
  .pipe(
    switchMap(() => {
      this.deliveryLoading = true;
      return this.orderService.getProofOfDeliveryData(this.documentId)
        .pipe(
          map((pdfData: { data: string }) => {
            const filename = `ProofOfDelivery_${this.documentId}.pdf`;
            this.downloadService.downloadPDF(pdfData.data, filename);
            return true;
          }),
          catchError(error => {
            this.toastService.errorMessage("ProofOfDeliveryComponent", "getProofOfDeliveryData", "getProofOfDeliveryData", error);
            return of(false);
          })
        );
    }),
    tap(() => this.deliveryLoading = false)
  );

  constructor(
    private orderService: OrderService,
    private toastService: ToastService,
    private downloadService: DownloadService) {
  }

  downloadPdf() {
    this.deliverySubject.next(null);
  }
}
